<template>
    <div>
        <div class="card">
            <div class="card-header">Additional Information</div>
            <div class="card-body">
                <b-row>
                    <b-col>
                        <p>
                            Use this page to complete answers from previous page(s) where space was insufficient. Include
                            question number(s) with each answer. If you answered "yes" to any of the items on the
                            questionnaire page, please provide a brief statement for each yes answer. Any other pertinent
                            information can be added here as well.
                        </p>
                        <p>
                            If seeking license by reciprocity, use this space to provide contact information for your
                            current licensing agency so that we may properly follow up.
                        </p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" lg="12">
                        <BaseParagraphInput v-model="additionalInformation"
                            :v="$v.additionalInformation"
                            slug="additionalInformation"
                            label="Additional Information"
                            setId="addlInfo"
                        />
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
    import BaseParagraphInput from '@/components/templates/input/BaseParagraphInput.vue'
    import { required } from 'vuelidate/lib/validators'
    import minDate from '@/validators/minDate'
    import maxDate from '@/validators/maxDate'

    export default {
        data: () => {
            return {
                additionalInformation: null,
            }
        },

        props: {
            application: [Object]
        },

        components: {
            BaseParagraphInput
        },

        validations() {
            return {
                additionalInformation: { required: false },
                form: [ 'additionalInformation' ],
            }
        },

        methods: {
            validate() {
                this.$v.form.$touch();
                var isValid = !this.$v.form.$invalid
                this.$emit('on-validate', this.$data, isValid)
                return isValid                               
            },
        },

        watch: {
            application() {
                for (var prop in this.application) {
                    if (this.hasOwnProperty(prop)) {
                        this[prop] = this.application[prop];
                    }
                }
            }
        }
    }
</script>